var sm = {
  fontSize: 'p-14',
  padding: 'md'
};
var smBorder = {
  fontSize: 'p-14',
  padding: 'md',
  bordered: true
};
var smBorderDivider = {
  fontSize: 'p-14',
  padding: 'md',
  bordered: true,
  withDivider: true
};
var std = {
  fontSize: 'p-16',
  padding: '2xl'
};
var stdBorder = {
  fontSize: 'p-16',
  padding: '2xl',
  bordered: true
};
var stdBorderDivider = {
  fontSize: 'p-16',
  padding: '2xl',
  bordered: true,
  withDivider: true
};
var md = {
  fontSize: 'p-18',
  padding: 'md'
};
var mdBorder = {
  fontSize: 'p-18',
  padding: 'md',
  bordered: true
};
var mdBorderDivider = {
  fontSize: 'p-18',
  padding: 'md',
  bordered: true,
  withDivider: true
};
var lg = {
  fontSize: 'p-20',
  padding: 'lg'
};
var lgBorder = {
  fontSize: 'p-20',
  padding: 'lg',
  bordered: true
};
var lgBorderDivider = {
  fontSize: 'p-20',
  padding: 'lg',
  bordered: true,
  withDivider: true
};
var cardVariants = {
  sm: sm,
  'sm-border': smBorder,
  'sm-border-divider': smBorderDivider,
  std: std,
  'std-border': stdBorder,
  'std-border-divider': stdBorderDivider,
  md: md,
  'md-border': mdBorder,
  'md-border-divider': mdBorderDivider,
  lg: lg,
  'lg-border': lgBorder,
  'lg-border-divider': lgBorderDivider
};

export { cardVariants };
//# sourceMappingURL=card.variants.esm.js.map
